import { graphql } from '@/__generated__';
import { useQueryStable } from '../useQueryStable';

export const GetAccountTags = graphql(/* GraphQL */ `
  query AccountTags($accountId: BigInt!) {
    account(id: $accountId) {
      tags {
        name
      }
    }
  }
`);

type TagsProps = {
  accountId: number | undefined;
  pause?: boolean;
};

export const useAccountTags = ({ accountId = 0, pause }: TagsProps) => {
  const query = useQueryStable({
    query: GetAccountTags,
    variables: { accountId },
    pause: pause || !accountId,
  });

  return query;
};
